import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FontLibraryDropdown from './FontLibraryDropdown';
import classNames from 'classnames';
import { PopoverEx as SparkPopover, ControlledSelect } from '../../ui/sabre-spark-react-ex/index';
import { noop } from '../../../../lib/utils';

export default function FontConfiguratorRow(props) {
    return (
        <div className={classNames('row', 'font-configurator__row', props.className)}>
            <div className={'col-xs-6'}>
                {props.title === 'Default' ? <b>{props.title}</b> : <span>{props.title}</span>}
            </div>
            <div className={'col-xs-6'}>
                <SparkPopover
                    ref={props.nestedPopoverHandler}
                    isDisabled={props.isDisabled}
                    anchorX="right"
                    anchorY="middle"
                    className="col-xs-4"
                    toggleEl={
                        <label className="spark-select font-configurator__trigger has-value">
                            <div className={'spark-select__input'}>
                                <div style={{ fontFamily: props.value }}>{props.value}</div>
                            </div>
                            <span className="spark-label"></span>
                        </label>
                    }
                >
                    <FontLibraryDropdown onChange={props.onChange} />
                </SparkPopover>
            </div>
        </div>
    );
}

FontConfiguratorRow.defaultProps = {
    title: '',
    description: '',
    value: null,
    onChange: noop,
    nestedPopoverHandler: noop
};

FontConfiguratorRow.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    nestedPopoverHandler: PropTypes.func,
    isDisabled: PropTypes.bool
};


// WEBPACK FOOTER //
// ./src/components/widgets/FontConfigurator/FontConfiguratorRow.js